import React from 'react';
import WizardModalForm from '../common/wizard_titular_modal.js';
import services from '../../services.js';
import WizardDetailModalForm from '../common/wizard_detail_popup'
import ParcelRightTabData from "./parcel_right_tab_data"
import ParcelRightPanelCard from '../modules/parcel_right_card.js';

class ParcelRightPanel extends React.Component {

    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = {
            tab: "parcel",
            popUpForm: '',
            tabFormData: {},
            detailPopUp: '',
            entity_list: [],
            entity_list_object: {},
            tabShowData: {},
            paidata: [],
            ParcelRightTabDatadiv: null,
            optionsEntityList: '',
            paidatatostring:"",
            error:null,
        }
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        // this.getEntityList();
        this.setState({
            tabFormData: this.props.Parcel
        }, () => this.setTabDetail(this.state.tab))
    }
    componentDidUpdate(prevProp) {
        if (prevProp.date !== this.props.date) {
            this.setState({
                tabFormData: this.props.Parcel
            }, () => this.setTabDetail(this.state.tab))
        }
    }

    updateTabOnly = (tab) => {
        this.setState({
            tab
        }, () => this.setTabDetail(tab))
    }

    setTabDetail = (tab) => {
        try {
            let tabFormData = { ...this.state.tabFormData }
            let tabShowData = { ...this.state.tabShowData }
            tabShowData[tab] = tabFormData[tab]
            this.setState({
                tabShowData
            },()=>{
                this.setpaidata(tabShowData[tab]);
            })
        } catch (error) {
            this.setState({error})
        }
       
      
    }

    insertClickPopUp = () => {
        try {
            this.setState({
                popUpForm: ""
            })
    
            let popUpForm = (
                <WizardModalForm
                    tab={this.state.tab}
                    all_list={this.props.all_list}
                    closePopup={() => this.props.closePopup()}
                    // entity_list_object={this.state.entity_list_object}
                    parcelData={this.state.tabFormData[this.state.tab]}
                    Parcel={this.props.Parcel}
                    // entityList={this.state.entity_list}
                    getPopUpFormState={(data, tab) => this.getPopUpFormState(data, tab)}
                // getEntityList={(filter) => this.getEntityList(filter)}
                />
            )
            this.setState({
                popUpForm
            })
        } catch (error) {
            this.setState({error})
        }
    }

    detailClick = (row) => {
        try {
            let detailPopUp = (
                <WizardDetailModalForm closePopup={() => this.props.closePopup()} listData={row} tab={'detail'} />
            )
            this.setState({
                detailPopUp
            })
        } catch (error) {
            this.setState({error})
        }
    }


    setpaidata = async (data) => {
        let paidata = [];
        if (data && data[0]) {
            try {
                for (let index = 0; index < data.length; index++) {
                    const element = data[index];
                    let name = await this.getEntityName(element)
                    if(element.quota){
                        paidata.push({ value: parseFloat(eval(element.quota)).toFixed(2) + '% - '+ name })
                    }
                }
                // data.map((_r, i) => {
                //     if(_r.quota){
                //         paidata.push({ value: eval(_r.quota),category: this.state.entity_list_object[_r.entnum]  })
                //     }
                // })
            } catch (e) { 
                this.setState({error : e})
            }
        }
        // let  paidatatostring = ''
        // if(paidata.length > 0){
        //     paidatatostring = JSON.stringify(paidata);
        // }
        this.setState({
            paidata,
            // paidatatostring
        }, () => this.ParcelRightTabData())
    }

    getEntityName = async(row) => {
        let res = await services.EntityList.getEntityList('parcel', null, row.entnum)
        if(Object.keys(res.entity_row).length > 0){
            let name = res.entity_row[row.entnum].nome
            return name
        }else{
            return ''
        }
    }

    ParcelRightTabData = () => {

        let ParcelRightTabDatadiv = (
            <ParcelRightTabData
                date={new Date()}
                tab={this.state.tab}
                tabShowData={this.state.tabShowData}
                // paidatatostring={this.state.paidatatostring}
                // entity_list_object={this.state.entity_list_object}
                paidata={this.state.paidata}
                detailClick={(id) => this.detailClick(id)}
                insertClickPopUp={() => this.insertClickPopUp()}
            />
        )
        this.setState({
            ParcelRightTabDatadiv
        })
    }



    getPopUpFormState = (data, tab) => {

        let tabFormData = { ...this.state.tabFormData }
        if (tab === 'parcel')
            // tabFormData[tab]['titdireito'] = data.entnum * 10
            tabFormData[tab]['titdireito'] = data.entnum
        else
            tabFormData[tab] = data;
        //console.log("..returnData", tab, tabFormData)
        this.setState({
            tabFormData
        }, () => {
            this.props.handleSubmit(this.state.tabFormData)
            this.setTabDetail(tab)
        })
    }

    /*  Para renderizar o conteúdo html da página   */

    render() {
        if(this.state.error){
            throw this.state.error
        }
        return (
            <div className="last-box">
                <ParcelRightPanelCard cardData={this.props.Parcel} cardFor="parcel" />
                <div className="bg-white">
                    <div className="right-tab">
                        <ul className="nav nav-tabs">
                            <li className="nav-item">
                                <a onClick={() => this.updateTabOnly('parcel')} className="nav-link active" data-toggle="tab" href="#Titular">TITULAR</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link piaDetails"  onClick={() => this.updateTabOnly('parcelProperty')} data-toggle="tab" href="#PROPRIETARIOS">PROPRIETÁRIOS</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link piaDetails"  onClick={() => this.updateTabOnly('parcelExplorer')} data-toggle="tab" href="#Exploradores">EXPLORADORES</a>
                            </li>
                        </ul>
                        {
                            this.state.ParcelRightTabDatadiv
                        }
                    </div>
                    <div className="modal left-popup" id="left-popup">
                        <div className="modal-dialog modal-sm">
                            {
                                this.state.popUpForm
                            }
                        </div>
                    </div>
                    <div className="modal left-popup" id="left-detail-popup">
                        <div className="modal-dialog modal-sm">
                            {
                                this.state.detailPopUp
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


export default ParcelRightPanel;